import { render, staticRenderFns } from "./DownloadInvoice2.vue?vue&type=template&id=33a7568c&scoped=true"
import script from "./DownloadInvoice2.vue?vue&type=script&lang=js"
export * from "./DownloadInvoice2.vue?vue&type=script&lang=js"
import style0 from "./DownloadInvoice2.vue?vue&type=style&index=0&id=33a7568c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a7568c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
